<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:60%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["N"][obj_aa.I > 0? "EN": "AN"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content dpt-wtd">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["N"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        :disabled="isEdit"
                                                        @input="AgentGroupChange"
                                                        v-model="obj_aa['AGIT']"
                                                        ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                        <CCol col="6">

                                            <label class="col-form-label-sm">{{this.getLanguage['N']['DN']}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :placeholder="this.utilGetDDLanguage('N.DN')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        :options="dd_do"
                                                        :disabled="isEdit"
                                                        @input="DomainChange"
                                                        v-model="obj_aa['DI']"
                                                        ref="DI" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('DI','DN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage['N']['NT']}}<span class="required" /> :</label>
                                            <span class="WCMsg" v-if="this.obj_aa.T != null">{{ this.obj_aa.T.length }} / 200 </span>
                                            <span class="WCMsg" v-else> 0 / 200 </span>
                                            <CInput maxlength="200" vertical size="sm" :value="obj_aa.T" @change="v => obj_aa.T = v" ref="T" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('T','NT') }}</span>
                                        </CCol>

                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage['N']['L']}}<span class="required" /> :</label>
                                            <treeselect :defaultExpandLevel="Infinity"
                                                        valueConsistsOf='LEAF_PRIORITY'
                                                        :multiple="true"
                                                        :options="dd_lang"
                                                        :placeholder="this.utilGetDDLanguage('N.L')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        :limit=1
                                                        v-model="obj_aa['Lang']"
                                                        ref="Lang"></treeselect>
                                            <span class="ErrMsg">{{ ValidationErrMsg('Lang','L') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["N"]["S"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_aa['HS']" @change="v => obj_aa['HS'] = v.target.checked" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="3" v-show="obj_aa['HS']">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["SD"]}}<span class="required" /> :</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               v-model="dt_addSTS"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="dt_addSTS.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="dt_addSTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('ASD',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('ASD',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                        </CCol>
                                        <CCol col="3" v-show="obj_aa['HS']">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["ED"]}}<span class="required" /> :</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="left"
                                                               :auto-apply="true"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               v-model="dt_addSTS"
                                                               :ranges="getDefaultDateRange()">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="dt_addSTS.endDate != ''">
                                                        <CInput size="sm"
                                                                :value="dt_addSTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                @change="DateTimeChange('AED',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('AED',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label v-if="isEdit==false" class="col-form-label-sm">{{this.getLanguage['N']['I']}}<span class="required" /> :</label>
                                            <label v-if="isEdit==true" class="col-form-label-sm">{{this.getLanguage['N']['CI']}}<span class="required" /> :</label>
                                            <CTabs variant='tabs' id="imageURLTab">
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_aa.IUT === false ? true: false">
                                                    <img v-if="obj_aa['I'] > 0"
                                                         width="auto"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_aa['NIMG'])" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileSelected" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFile === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFile.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 1920 x 500</label>

                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_aa.IUT === true ? true: false">
                                                    <img v-if="obj_aa['I'] > 0"
                                                         width="auto"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_aa['NIMG'])" />
                                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                        </div>
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_aa.NIMG">
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 1920 x 500</label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol>
                                            <label class="col-form-label-sm">{{this.getLanguage['N']['NC']}}<span class="required" /> :</label>
                                            <editor id="htmluuid1" @onChange="HTMLEditorTextChange" :value="obj_aa.CBD" :init="init" ref="CBD" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('CBD','NC') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center">
                                    <CButton color="outline-info"
                                             size="sm"
                                             style="margin-top:20px"
                                             @click="saveNews()">
                                        <span class="plusIcon cil-plus"></span>
                                        {{this.getLanguage['BTN']['SV']}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader position-relative">
                        <h2 id="titleHeight">{{this.getLanguage["N"]["NF"]}}</h2>
                        <CButton size="sm"
                                 color="outline-info"
                                 data-toggle="NewsAddmodal"
                                 data-target="#myModal"
                                 v-if="checkModuleAccess2(constAccessType.add)"
                                 @click="addNews()">
                            <span class="plusIcon cil-plus"></span>{{this.getLanguage["BTN"]["AN"]}}
                        </CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class="searchBox">
                            <div class="searchCol">
                                <span class="searchLabel"> {{this.getLanguage['DM']['AGI']}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{this.getLanguage["N"]["NS"]}} :</span>
                                <treeselect :multiple="false" :options="Status" :placeholder="this.utilGetDDLanguage('N.NS')" v-model="str_FV[3].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   v-model="str_FV[4].FV"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[4].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[4].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   v-model="str_FV[4].FV"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[4].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[4].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{this.getLanguage["N"]["D"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('N.D')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            :limit="1"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class="searchCol">
                                <label class="searchLabel">{{this.getLanguage["N"]["L"]}} :</label>
                                <treeselect :defaultExpandLevel="Infinity"
                                            valueConsistsOf='LEAF_PRIORITY'
                                            :multiple="true"
                                            :options="dd_langfs"
                                            :placeholder="this.utilGetDDLanguage('N.L')"
                                            :limit="1"
                                            v-model="str_FV[2].FV"></treeselect>
                            </div>
                        </div>
                        <div class="searchBtnCol">
                            <CButton class="searchBtn" ref="search" size="sm" block color="success" v-shortkey="['enter']" @shortkey="newSearch()" @click="newSearch()">
                                <span class="searchIcon cil-search"></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class="table-wrapper">
                <header class="table-header">
                    <strong>{{this.getLanguage["N"]["NFL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th rowspan="2">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["ST"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["NT"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["C"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["N"]["S"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["A"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["L"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["N"]["F"]}}</th>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171)">{{this.getLanguage["N"]["T"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th rowspan="2">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["ST"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["NT"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["C"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["N"]["S"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["A"]}}</th>
                                <th rowspan="2">{{this.getLanguage["N"]["L"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["N"]["F"]}}</th>
                                <th id="nestedTableR2" style="border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171)">{{this.getLanguage["N"]["T"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_al.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_al">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-trash" @click="removeNews(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-color-border" @click="editNews(data.I, data.AR)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span :style="`color:${data.status  ? 'green':'red' }`">{{renderStatus(data.status)}}</span>
                            </td>
                            <td>{{ substrContent(data.T,40) }}</td>
                            <td>{{  substrContent(data.CBD,40) }}</td>
                            <td v-if="data.HS == false">{{getLanguage["AN"]["IN"]}}</td>
                            <td v-else>{{ formatDateTime(data.STS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td v-if="data.HS == false">{{getLanguage["AN"]["IN"]}}</td>
                            <td v-else>{{ formatDateTime(data.ETS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.DN }}</td>
                            <td><span class="grid-line" v-for="lang in data.Languages">{{ lang }}</span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    import Treeselect from "@riophae/vue-treeselect";
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import moment from "moment";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    import { mapGetters, mapActions } from "vuex";
    import Loading from "vue-loading-overlay";
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, minLength, between, url } from "vuelidate/lib/validators";
    import Axios from "axios";
    import { constAccessType, constStatus, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import Editor from '@tinymce/tinymce-vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            DateRangePicker,
            Loading,
            'editor': Editor
        },
        data() {
            return {
                bool_CV: false,
                dt_addSTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                },
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                Status: [],
                int_TP: 1, //Total Page
                str_tableSortBy: "CreatedTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                isEdit: true,
                bool_showSearchBar: true,
                str_FV: [
                    { F: "AGI" },
                    { F: "DI" },
                    { F: "L_csv", FA: true },
                    { F: "Status" },
                    {
                        F: "STS", FV: {
                            startDate: "",
                            endDate: ""
                        }
                    },
                ], //Filter Value
                bool_isEx: false, // Expend
                bool_isTMV: false, // Table Modal Visible
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                arry_al: [], //News List
                obj_aa: {
                    I: 0,
                    RS: 1,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    T: null,
                    L: [],
                    CBD: null,
                    STS: 0,
                    ETS: 0,
                    AGI: null,
                    AGIT: null,
                    DI: null,
                    HS: false,
                    NIMG: "",
                    Lang: [],
                    IUT: false,
                },
                //dd_lang: [{ id: 'all', label: 'All', children: [] }],
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                //dd_domainN: null,
                dd_do: [],
                dd_dofs: [],
                dd_lang: [],
                dd_langfs: [],
                hodDI: null,
                selectedFile: null,
                newImg: false,
                str_AR: [],
                addLanguage: null,
                constAccessType: constAccessType,
                init: {
                    height: 500,
                    plugins: [
                        'lists advlist',
                        'image imagetools',
                        'link autolink',
                        'table',
                        'charmap',
                        'searchreplace visualblocks code fullscreen',
                        'print preview anchor insertdatetime',
                        'help codesample hr pagebreak nonbreaking toc textpattern noneditable',
                        'importcss',
                        'directionality',
                        'visualchars',
                        'emoticons',
                        'autosave',
                        'wordcount'
                    ],
                    toolbar:
                        'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                    branding: false,
                    menubar: true,
                    file_picker_callback: function (cb) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            this.bool_fullLoading = true;
                            var file = this.files[0];
                            var reader = new FileReader();

                            if (!file) {
                                return;
                            }
                            if (!file.name.match(/\.(jpg|jpeg|png)$/)) {
                                return;
                            }

                            reader.onload = function () {
                                var that = this;
                                var formData = new FormData();
                                formData.append('image', file)

                                Axios({
                                    url: 'https://api.imgur.com/3/image',
                                    method: 'POST',
                                    headers: {
                                        'Authorization': 'Client-ID ' + constImgURClientId
                                    },
                                    data: formData
                                })
                                    .then((result) => {
                                        let url = result.data.data.link;
                                        that.bool_fullLoading = true;
                                        cb(url, { title: file.name });
                                    })
                                    .catch((err) => {
                                        that.bool_fullLoading = true;
                                        console.log(err);
                                    });
                            };
                            reader.readAsDataURL(file);
                        };
                        input.click();
                    }
                }
            };
        },
        validations: {
            obj_aa: {
                AGIT: { required },
                CBD: { required },
                DI: { required },
                T: { required },
                Lang: { required },
            },

        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getNewsList();
                this.Status();
            },
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[4].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[4].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[4].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[4].FV.endDate = "";
                    }
                }
                if (type == "ASD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dt_addSTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.dt_addSTS.startDate = "";
                    }
                }
                if (type == "AED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dt_addSTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.dt_addSTS.endDate = "";
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "CBD") {
                    this.obj_aa.CBD = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('NE', 'CMS', type);
            },
            getNewsStatus() {
                this.Status = [{ id: '1', label: this.getLanguage['GL']['DISB'] }, { id: '2', label: this.getLanguage['GL']['ENB'] }];
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getNewsList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getNewsList();
                }
            },
            returnAGI(value) {
                if (value != null) {
                    var agi = value.split("-");
                    agi = agi[1];
                    return agi;
                }
                else {
                    return null;
                }
            },
            getDropdownList() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`, function (d, s) {
                    if (s) {
                        that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
                    }
                });
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            //loadDomainOptions({ action, callback, instanceId }) {
            //    var that = this;
            //    if (this.obj_aa.AGIT == null) {
            //        callback(this.getLanguage['MEM']['PSAA']);
            //    }
            //    else {
            //        this.getDataApi(`/api/dd/dn/${this.returnAGI(this.obj_aa.AGIT)}`,
            //            function (d, s) {
            //                if (s && d && d.dropdownlist) {
            //                    that.dd_domainN = d.dropdownlist;

            //                }
            //                else {
            //                    that.dd_domainN = null;
            //                }

            //                callback();
            //            });
            //    }

            //},
            //getDomain({ action, callback, instanceId }) {
            //    var that = this;
            //    if (this.str_FV[0].FV == null || this.str_FV[0].FV == undefined) {
            //        callback(this.getLanguage['MEM']['PSAA']);
            //    }
            //    else {
            //        this.getDataApi(`/api/dd/dn/${this.returnAGI(this.str_FV[0].FV)}`,
            //            function (d, s) {

            //                if (s && d && d.dropdownlist) {
            //                    that.dd_do = d.dropdownlist;

            //                }
            //                else {
            //                    that.dd_do = null;
            //                }

            //                callback();
            //            });
            //    }
            //},
            //ClearDD(value) { //here clear option and select
            //    this.dd_domainN = null;

            //},
            //Clear_S_DD(value) {
            //    this.dd_do = null;
            //},
            setSortTable(SV) {
                //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort; //change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getNewsList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF
                    ? this.bool_isSort
                        ? "sort-descending"
                        : "sort-ascending"
                    : "list"
                    }`; //here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[4].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            getNewsList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(
                    this.int_Page,
                    this.int_RC,
                    this.str_tableSortBy,
                    this.bool_isSort
                );
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].F == "Status" && this.str_FV[i].FV != "") {
                            var date_temDate = this.parseDateToJsonString(new Date());
                            switch (this.str_FV[i].FV) {
                                case "2":
                                    path += "&f[STS_to]=" + date_temDate + "&f[ETS_from]=" + date_temDate
                                    break;
                                case "1":
                                    path += "&f[STS_from]=" + date_temDate
                                    break;
                                case "0":
                                    path += "&f[ETS_to]=" + date_temDate
                                    break;
                            }
                        }
                        else if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        //else if (this.str_FV[i].F == "AGI") {

                        //    path += "f[AGI]=" + this.returnAGI(this.str_FV[i].FV);
                        //}
                        else if (this.str_FV[i].F == 'STS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "" && this.str_FV[i].FV.endDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);

                                var full = cts_from + "," + cts_to;
                                path += ("f[STS_drsft]=" + full + "&f[ETS_dreft]=" + full);
                            }
                        }
                        else {
                            path += "f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV;
                        }
                    }
                }

                this.getDataApi(`/api/news/l?${path}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setNewsList(d.D);
                        that.resizeTableHead();
                    }
                });
            },
            setNewsList(data) {
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_Total = data.TotalItems;
                this.arry_al = data.Items;


            },
            setNews(data) {
                this.obj_aa = Object.assign(this.obj_aa, data);
                //split id for tree select
                var arry_splitLang = this.obj_aa["L"].split(",");
                this.obj_aa.Lang = arry_splitLang;

                if (this.obj_aa.AGI != 0) {
                    this.obj_aa.AGIT = "3-" + this.obj_aa.AGI;
                    this.AgentGroupChange(this.obj_aa.AGIT);
                }

                if (this.obj_aa["HS"]) {
                    this.dt_addSTS.startDate = this.obj_aa.STS;
                    this.dt_addSTS.endDate = this.obj_aa.ETS;
                }
                else {
                    this.dt_addSTS.startDate = this.getTodayDate();
                    this.dt_addSTS.endDate = this.getTodayEndDate();
                }
                this.DomainChange(data.DI);
                this.bool_isAMV = true;
            },
            addNews() {
                this.obj_aa = {
                    I: 0,
                    RS: 1,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    T: null,
                    L: [],
                    CBD: null,
                    STS: 0,
                    ETS: 0,
                    AGI: null,
                    AGIT: null,
                    DI: null,
                    HS: false,
                    NIMG: "",
                    Lang: [],
                    IUT: false
                };
                //this.ClearDD();
                this.newImg = false;
                this.selectedFile = null,
                    this.dt_addSTS.startDate = this.getTodayDate();
                this.dt_addSTS.endDate = this.getTodayEndDate();
                this.isEdit = false;
                this.bool_isAMV = true;
                this.bool_CV = false;
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_aa.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_aa.AGIT);
                    }
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_aa[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["N"][langKey]);
                    }
                }

            },
            getIURLTabIndex() {
                var result = 0;
                try {
                    var x = document.querySelector('#imageURLTab .nav.nav-tabs li a.active').innerText;
                    if (x == "Upload Image") {
                        result = 1;
                        return result;
                    }
                    else if (x === undefined) {
                        return result;
                    }
                    else {
                        result = 2;
                        return result;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
                return result;
            },
            HTMLEditorTextChange(value) {
                this.obj_aa.CBD = value.level.content;
            },
            saveNews() {
                this.bool_CV = true;
                var iurlTab = this.getIURLTabIndex();
                if (iurlTab != 1) { // external img url
                    if (this.obj_aa.NIMG != null && this.obj_aa.NIMG != "") {
                        //if img url is not empty
                        this.obj_aa.IUT = true;
                        this.newImg = true;
                    }
                }
                this.$v.obj_aa.$touch();
                var that = this;
                if (!this.$v.obj_aa.$error) {

                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;

                    // check if schedule is set
                    if (this.obj_aa["HS"]) {
                        this.obj_aa["STS"] = moment(this.dt_addSTS.startDate).format("YYYY-MM-DD HH:mm:ss");
                        this.obj_aa["ETS"] = moment(this.dt_addSTS.endDate).format("YYYY-MM-DD HH:mm:ss");
                    }
                    else {
                        this.obj_aa["STS"] = moment(this.getMinimumDate()).format("YYYY-MM-DD HH:mm:ss");
                        this.obj_aa["ETS"] = moment(this.getMaximumDate()).format("YYYY-MM-DD HH:mm:ss");
                    }

                    var temp_lang = "";
                    for (var i = 0; i < this.obj_aa["Lang"].length; i++) {
                        if (i != 0) {
                            temp_lang += ",";
                        }
                        temp_lang += this.obj_aa.Lang[i];
                    }
                    this.obj_aa["L"] = temp_lang;


                    if (this.obj_aa.AGIT != "" && this.obj_aa.AGIT != null) {
                        var agi = this.obj_aa.AGIT.split("-");
                        this.obj_aa.AGI = agi[1];
                    }

                    if (this.newImg == true) {
                        //if new image is selected
                        this.obj_aa['Image'] = this.selectedFile;
                        this.postDataApiWithAttach(`/api/news/s`, this.obj_aa, function (d, s) {
                            that.bool_isAMV = false;
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.selectedFile = null;
                                that.getNewsList();
                            }
                        });
                    } else if (this.newImg == false && this.obj_aa["I"] > 0) {
                        //if user edit, but want to retain image
                        this.postDataApi(`/api/news/s`, this.obj_aa, function (d, s) {
                            that.bool_isAMV = false;
                            that.bool_fullLoading = false;
                            if (s) {
                                that.selectedFile = null;
                                that.getNewsList();
                            }
                        });
                    } else {
                        that.bool_fullLoading = false;
                        that.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4002")));
                    }
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_aa"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeNews(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            DI: d.DI,
                            uts: d.UTS
                        };

                        this.postDataApi(`/api/news/d`, dt, function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.getNewsList();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                    }
                });
            },
            editNews(id, AR) {
                this.bool_fullLoading = true;
                var that = this;
                this.newImg = false;
                this.getDataApi(`/api/news/g/${id}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.isEdit = true;
                        that.setNews(d.D);
                    }
                });
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event);
                this.newImg = true;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            renderStatus(index) {

                if (index) {
                    return this.Status[1].label;
                } else {
                    return this.Status[0].label;
                }

            },
            AgentGroupChange(value) {
                if (value) {
                    if (this.obj_aa['I'] == 0) {
                        this.obj_aa['DI'] = null;
                    }
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }

                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_do = d.dropdownlist
                            }
                        });
                }
            },
            AgentGroupChangefs(value) {
                var that = this;
                if (value) {
                    var agi = 0;
                    if (value != "")
                        agi = value.split("-")[1];
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                            }
                        });
                    that.str_FV[0].FV = agi;
                }
                else {
                    that.dd_dofs = [];
                    that.str_FV[0].FV = null;
                }
                that.str_FV[1].FV = null;
            },
            DomainChange(value) {
                var that = this;
                if (value && value > 0) {
                    this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
                        if (s) {
                            that.dd_lang = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });
                }
                else {
                    that.dd_lang = [];
                }
                if (that.obj_aa.I == 0)
                    that.obj_aa.Lang = [];
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);

                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const allHeaderRows = this.$el.querySelectorAll('#tHead .custom-table thead tr');

                if (!allHeaderRows.length) return; // Early return if no header rows

                tables.forEach((table) => {
                    let nestedIndex = 0;

                    // Collect body cells from the first row
                    const bodyCells = Array.from(table.querySelectorAll('tbody tr:nth-child(1) td'));
                    if (!bodyCells.length) return; // Early return if no body cells

                    // Reset all widths before applying new ones
                    const bodyCellElements = table.querySelectorAll('tbody tr td');
                    [...allHeaderRows[0].querySelectorAll('th'), ...bodyCellElements].forEach(cell => cell.style.width = '');

                    // Apply widths to header and body cells
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        const isNested = [5, 6].includes(index);
                        const headerRow = isNested ? 2 : 1;
                        const headerCells = this.$el.querySelectorAll(`#tHead .custom-table thead tr:nth-child(${headerRow}) th`);

                        let headerCell = headerCells[isNested ? nestedIndex : index];
                        if (index === 7) {
                            headerCell = headerCells[6];
                        } else if (index === 8) {
                            headerCell = headerCells[7];
                        }

                        // Update header cell styles
                        if (headerCell) {
                            headerCell.style.width = width;
                        }

                        // Update body cell styles for the corresponding column
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach((td) => {
                            td.style.width = width;
                        });

                        // Increment nestedIndex for nested columns
                        if (isNested) nestedIndex++;
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            //DomainChangefs(value) {
            //    var that = this;
            //    if (value && value > 0) {
            //        this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
            //            if (s) {
            //                that.dd_langfs = that.appendSelectAllOption(d.dropdownlist);
            //            }
            //        });
            //    }
            //    else {
            //        that.dd_langfs = [];
            //    }
            //    that.str_FV[2].FV = [];
            //},
        },
        created() {
            this.$parent.showSubMenu = 'CMS';
            this.$parent.showActiveMenu = 'CMS.NE';
            if (this.$route.path == '/WEBS/NE') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showSubSubMenu = 'CMS1';
                this.$parent.showActiveMenu = 'WEBS.NE';
            }
            this.getNewsList();
            this.getDropdownList();
            this.getNewsStatus();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        }
    };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/ContentManagementSystem/News.vue